module.exports = __webpack_public_path__ + "img/stepvan_stopped.73b18658.svg";